/**
 * Azure secret patterns
 *
 * Sources:
 * https://learn.microsoft.com/en-us/dotnet/api/azure.identity.environmentcredential
 * https://learn.microsoft.com/en-us/microsoft-365/compliance/sit-defn-azure-ad-client-secret
 */

const QUOTE = `["']?`;
const CONNECT = '\\s*(?::|=>|=|:=)\\s*';
const GUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const SECRET = '[-_.~a-z0-9]{40}';

export const azureClientId = new RegExp(
  String.raw`${QUOTE}(?:azure|ad)_?tenant_?id${QUOTE}${CONNECT}${QUOTE}(${GUID})${QUOTE}\b`,
  'i'
);

export const azureClientSecret = new RegExp(
  String.raw`${QUOTE}(?:azure)?_?client_?secret${QUOTE}${CONNECT}${QUOTE}(${SECRET})${QUOTE}\b`,
  'i'
);
